
  import { Vue, Component } from "vue-property-decorator";

  import AuthWarning from "@/components/alert/AuthWarning.vue";

  @Component({
    components: {
      AuthWarning,
    }
  })
  export default class ManagerAccessDeniedWarning extends Vue {}
